import React from 'react'
import { useState,useEffect } from 'react';
import ReportsAPI from '../../Common/AgileNetwork/ReportsAPI';
//import { Reports_URL } from '../../Common/config';

//import { Modal } from 'react-bootstrap';
import { useWebProperties } from '../../Common/webProperties';
import moment from 'moment';
import Select from 'react-select'
import RootLoader from '../../Common/Loader/RootLoader';
import { useSelector } from 'react-redux';
// import { startOfWeek, endOfWeek } from 'date-fns';
// import { DateRangePicker } from 'react-date-range';
import { getDecimalHours } from '../../Common/convertDecimalHoursToTime';
import API from '../../Common/Network/API';
import { removeDuplicatesFromString } from '../../Common/commonUsage';
import UserProjectInfo from './userProjectInfo';
// import $ from 'jquery';

//import { Link } from 'react-router-dom';
import { logEntry } from '../../Common/logEntry';
import ProjectCosting from './ProjectCosting';
import { CSVLink } from 'react-csv';

const UserCosting = ({filter,display,ActiveC}) => {
     // eslint-disable-next-line
   const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
  //  const handleShow = () => setShow(true);
    const [open, setOpen] = useState({ status: false, index: 0 })
    const [info, setInfo] = useState();
    const [loader, setLoader] = useState(false);
    const { NO_OF_PROJECTS_INVOLVED, EMPLOYEE_NAME , TOTAL_HOURS, } = useWebProperties();

      const handleModalClose = () => {
        setOpen({ status: false, index: 0 });
    }
    const properties = useSelector(state => state.landingReducer.properties)
    const [result, setResult] = useState([])
    const getUser = useSelector(state => state.auth)
    const [filterData, setFilterData] = useState([])
    const [searchFilterData, setSearchFilterData] = useState([]);
    const [groupDetails, setGroupDetails] = useState([])
    const [selectedGroupDetails, setSelectedGroupDetails] = useState([])
    const [searchQuery, setSearchQuery] = useState('');
    const [sortColumn, setSortColumn] = useState('');
    const [sortDirection, setSortDirection] = useState('');
    const [activeComponent, setActiveComponent] = useState('user');
    const activities = useSelector(state => state.landingReducer.userActivities)
    const [message, setMessage] = useState('');
    useEffect(() => {
        getAdminGroupDetails(getUser.user)
        // eslint-disable-next-line
    }, [])

useEffect(() => {
  const columnKeyMap = {
    'Total No of Projects': 'Total_No_of_Projects',
    'Total No of Tasks': 'Total_No_of_Tasks',
    'Total No of Hours Worked': 'Total_No_of_Hours_Worked',
    'Total Paid ($)': 'Total_Paid',
    'Total Bill ($)': 'Total_Bill',
    'Name': 'name'
  };

  const sortData = (data) => {
    const key = columnKeyMap[sortColumn] || sortColumn;

    return data.slice().sort((a, b) => {
      if (key === 'name') {
        const nameA = a.name.toLowerCase();
        const nameB = b.name.toLowerCase();
        return sortDirection === 'asc'
          ? nameA.localeCompare(nameB)
          : nameB.localeCompare(nameA);
      }

      const getValue = (item) => {
        const hours = parseFloat(item.data?.[0]?.Total_No_of_Hours_Worked || 0);

        if (key === 'Total_Paid') {
          return parseFloat(item.pay_rate || 0) * hours;
        } else if (key === 'Total_Bill') {
          return parseFloat(item.bill_rate || 0) * hours;
        } else {
          return parseFloat(item.data?.[0]?.[key] || 0);
        }
      };

      const aVal = getValue(a);
      const bVal = getValue(b);

      return sortDirection === 'asc' ? aVal - bVal : bVal - aVal;
    });
  };

  if (searchQuery.length > 0) {
    setSearchFilterData(prevData => sortData(prevData));
  } else {
    setFilterData(prevData => sortData(prevData));
  }
  // eslint-disable-next-line
}, [sortColumn, sortDirection]);


  const filterGroup = (data, groupDetails) => {
      let emailArray = groupDetails.emails.split(',')

      return data.filter(obj => emailArray.includes(obj.email))
  }



  const searchFilter = (data, searchData) => {
    return data.filter(
      (item) =>
        item.name.toLowerCase().includes(searchData.toLowerCase()) ||
        item.data[0].Total_No_of_Projects.toString().toLowerCase().includes(searchData.toLowerCase()) ||
        (item.data[0].Total_No_of_Tasks !== null &&
          getDecimalHours(item.data[0].Total_No_of_Tasks).toString().toLowerCase().includes(searchData.toLowerCase())) ||
        (item.data[0].Total_No_of_Hours_Worked !== null &&
          item.data[0].Total_No_of_Hours_Worked.toString().toLowerCase().includes(searchData.toLowerCase()))
    );
  };

  useEffect(() => {
    if (selectedGroupDetails.value !== 'All' && selectedGroupDetails.length !== 0) {
        let filteredData = filterGroup(result, selectedGroupDetails);

        setFilterData(filteredData);
        if (searchQuery.length > 0) setSearchFilterData(searchFilter(filteredData, searchQuery));

    }
    else {
        setFilterData(result);
        if (searchQuery.length > 0) setSearchFilterData(searchFilter(result, searchQuery));
    }
  }, [result, selectedGroupDetails, searchQuery]);

  const debounce = (func, delay) => {
    let timeoutId;
    return function (...args) {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        func.apply(this, args);
      }, delay);
    };
  };

  const debouncedSearch = debounce((value) => {
    if (value.length > 0) {
      setSearchFilterData(searchFilter(filterData, value));
    } else {
      setSearchFilterData([]);
    }
  }, 1000);

  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
    debouncedSearch(event.target.value);
  };

  const handleOpen = (index, action, task_status, column_name) => {
    setOpen({ status: true, index: index, action: action });
    let dateFilter = [
      {
        startDate: moment(filter[0].startDate).format('YYYY-MM-DD'),
        endDate: moment(filter[0].endDate).format('YYYY-MM-DD'),
        key: 'selection',
      },
    ];
    let info = {};
    if (action === 'costingProject') {
      info = {
        user_id: searchQuery.length === 0 ? filterData[index].emp_id : searchFilterData[index].emp_id,
        action: 'costingProject',
        name: searchQuery.length === 0 ? filterData[index].name : searchFilterData[index].name,
        //   account_id:extension === 'agile24x7.com' ? "" : getUser.user.account_id,
        dateFilter,
        column_name,
        pay_rate: searchQuery.length === 0 ? filterData[index].pay_rate : searchFilterData[index].pay_rate
      }
  }

//   get total tasks
if (action === "totalTasks") {
    info = {
        user_id: searchQuery.length === 0 ? filterData[index].emp_id : searchFilterData[index].emp_id,
        action: 'totalTasks',
        name: searchQuery.length === 0 ? filterData[index].name : searchFilterData[index].name,
        dateFilter,
        column_name,
         pay_rate: searchQuery.length === 0 ? filterData[index].pay_rate : searchFilterData[index].pay_rate
    }
}

  setInfo(info);
};

const handleSort = (column) => {
  if (sortColumn === column) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
  } else {
      setSortColumn(column);
      setSortDirection('asc');
  }
};

  const getSortIcon = (column) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="currentColor"
        className="bi bi-arrow-down-up"
        viewBox="0 0 16 16"
      >
        <path
          fillRule="evenodd"
          d="M11.5 15a.5.5 0 0 0 .5-.5V2.707l3.146 3.147a.5.5 0 0 0 .708-.708l-4-4a.5.5 0 0 0-.708 0l-4 4a.5.5 0 1 0 .708.708L11 2.707V14.5a.5.5 0 0 0 .5.5m-7-14a.5.5 0 0 1 .5.5v11.793l3.146-3.147a.5.5 0 0 1 .708.708l-4 4a.5.5 0 0 1-.708 0l-4-4a.5.5 0 0 1 .708-.708L4 13.293V1.5a.5.5 0 0 1 .5-.5"
        />
      </svg>
    );
  };

async function getAdminGroupDetails(getUser) {
  try {
    setMessage('');
      var response = await API.post("group_chat.php", {
          action: 'getAdminGroupDetails',
          created_by: getUser.userName,
          projectId: getUser.projectId,
          userType: getUser.role,
          empId: getUser.empId,
      },{},false);
      if (response.status === 'True') {
          setGroupDetails(response.data);
      }
      else {
        setGroupDetails([])
      }
  } catch (error) {
    setMessage(error.message);
      console.log('error', error.message);
  }
}
async function Network(api, state, filter) {
  setResult([])
  setLoader(true)
  try {
    setMessage('');
      const start_time = Date.now()
      const response = await ReportsAPI.post(`/${api}`, 
          { filter,account_id:extension === 'agile24x7.com' ? "" : getUser.user.account_id }, {}, false)
      const end_time = Date.now()

      activities && logEntry({user_id:getUser.user.userName,logging_level:3,activity_id:activities["Admin"],sub_activity:"UserCosting",response_time:(end_time-start_time)},getUser)

      await state(response)
      setLoader(false)
  }
  catch (error) {
      setLoader(false)
      setMessage(error.message)
      activities && logEntry({user_id:getUser.user.userName,logging_level:2,activity_id:activities["Admin"],sub_activity:"UserCosting",error_message:error.message},getUser)
//console.log('error', error.message)
  }
}

  const getCosting = () => {
    handleClose();
    let dateFilter = [
      {
        startDate: moment(filter[0].startDate).format('YYYY-MM-DD'),
        endDate: moment(filter[0].endDate).format('YYYY-MM-DD'),
        key: 'selection',
      },
    ];
    Network('getCostingData', setResult, dateFilter);
  };

  useEffect(() => {
    if (display) {
      getCosting();
    }
    // eslint-disable-next-line
  }, [display]);

  const handleSelectedGroups = (selectedOption) => {
    setSelectedGroupDetails(selectedOption);
    if (selectedOption.value === 'All') {
      setFilterData(result);
    } else {
      setFilterData(filterGroup(result, selectedOption));
    }
    setSearchQuery('');
    setSearchFilterData([]);
  };

  const getCsvData = () => {
    const dataToExport = searchQuery.length === 0 ? filterData : searchFilterData;
    const headers = [
      properties?.EMPLOYEE_NAME || EMPLOYEE_NAME,
      'Total No of Projects',
      'Total No of Tasks',
      properties?.TOTAL_HOURS || TOTAL_HOURS,
    //   'Pay Rate ($)',
      'Total Paid ($)',
      'Total Bill ($)',
    ];

    const csvData = [
      headers,
      ...dataToExport.map((x) => [
        x.name,
        x.data[0].Total_No_of_Projects,
        x.data[0].Total_No_of_Tasks,
        x.data[0].Total_No_of_Hours_Worked !== null ? getDecimalHours(x.data[0].Total_No_of_Hours_Worked) : 0,
        x.pay_rate,
        x.data[0].Total_No_of_Hours_Worked !== null && x.pay_rate !== 0
          ? (x.data[0].Total_No_of_Hours_Worked * x.pay_rate).toFixed(2)
          : '0',
        x.data[0].Total_No_of_Hours_Worked!==null && x.bill_rate !==0
          ? (x.data[0].Total_No_of_Hours_Worked * x.bill_rate).toFixed(2)
           : '0',
      ]),
    ];

    return csvData;
  };

  const [, extension] = getUser.user.userName.split('@');

  return (
    <div>
      {activeComponent === 'user' ? (
        <div className="mt-2">
          <div className="col-lg-12 grid-margin stretch-card">
            <div className="card">
              <div className="card-body">
                <div className="d-flex justify-content-between row">
                  {message && (
                    <>
                      <br />
                      <br />
                      <span style={{ color: 'red', marginLeft: '10%' }}>{message}</span>
                    </>
                  )}
                </div>
                <div className="d-flex align-items-start justify-content-between mt-1">
                  <div className="d-flex flex-column">
                    <div className="d-flex align-items-center mb-2">
                      <button
                        className={`btn mr-4 ${!ActiveC ? 'btn-success' : 'text-success border border-success'}`}
                      >
                        User Costing
                      </button>
                      <button
                        className={`btn ${ActiveC ? 'btn-success' : 'text-success border border-success'}`}
                        onClick={() => setActiveComponent('project')}
                      >
                        Project Costing
                      </button>
                    </div>
                    <CSVLink
                      className="downloadbtn btn btn-primary"
                      filename="WeTasker.csv"
                      data={getCsvData()}
                    >
                      Export
                    </CSVLink>
                  </div>
                  <div className="d-flex flex-column align-items-end">
                    <div className="d-flex mb-2" style={{ width: '350px' }}>
                      <label className="mr-2 mb-0 mt-2" htmlFor="groupSelect">
                        Group:
                      </label>
                      <Select
                        className=""
                        placeholder="Select Group"
                        styles={{
                          control: (provided) => ({
                            ...provided,
                            width: '300px',
                            height: '30px',
                            minHeight: '30px',
                          }),
                          valueContainer: (provided) => ({
                            ...provided,
                            height: '30px',
                            padding: '0 6px',
                          }),
                          input: (provided) => ({
                            ...provided,
                            margin: '0',
                            padding: '0',
                          }),
                          indicatorsContainer: (provided) => ({
                            ...provided,
                            height: '30px',
                          }),
                        }}
                        options={[
                          { value: 'All', label: 'All' },
                          ...(groupDetails?.map((group) => ({
                            value: group.id,
                            label: `${group.group_name}-[${removeDuplicatesFromString(group.members_name)}]`,
                            emails: group.members_email,
                          })) || []),
                        ]}
                        onChange={handleSelectedGroups}
                      />
                    </div>
                    <div className="d-flex justify-content-end">
                      <label className="mr-2 mb-0 mt-2" htmlFor="searchInput">
                        Search:
                      </label>
                      <input
                        type="text"
                        className=""
                        style={{ height: '30px', width: '300px', border: '2px solid black', paddingLeft: '7px' }}
                        aria-label="Search"
                        aria-describedby="basic-addon2"
                        onChange={handleSearch}
                        value={searchQuery}
                      />
                    </div>
                  </div>
                </div>
                <div className="p-2">
                  <div className="pt-2" />
                  {result.length !== 0 ? (
                    <div className="table-responsive">
                      <table
                        search="true"
                        className="table table-striped table-bordered"
                        data-pagination="true"
                      >
                        <thead style={{ backgroundColor: '#F4FAF7' }}>
                          <tr>
                            <th className="text-capitalize" onClick={() => handleSort('name')}>
                              {properties?.EMPLOYEE_NAME || EMPLOYEE_NAME} {getSortIcon('name')}
                            </th>
                            <th onClick={() => handleSort('Total_No_of_Projects')}>
                              Total No of Projects
                            </th>
                            <th onClick={() => handleSort('Total_No_of_Tasks')}>Total No of Tasks</th>
                            <th onClick={() => handleSort('Total_No_of_Hours_Worked')}>
                              {properties?.TOTAL_HOURS || TOTAL_HOURS} {getSortIcon('total_hours')}
                            </th>
                            {/* <th>Pay Rate ($)</th> */}
                            <th onClick={() => handleSort('Total_Paid')}>
                              Total Paid ($) {getSortIcon('Total_Paid')}
                            </th>
                            <th onClick={() => handleSort('Total_Bill')}>
                              Total Bill ($) {getSortIcon('Total_Bill')}
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {(searchQuery.length === 0 ? filterData : searchFilterData).map(
                            (x, index) => (
                              <tr key={index}>
                                <td
                                  style={{
                                    height: 40,
                                    fontWeight: 'bold',
                                    color: 'green',
                                    cursor: 'pointer',
                                  }}
                                >
                                  <p style={{ color: 'green', fontSize: '0.8rem' }}>{x.name}</p>
                                </td>
                                <td
                                  style={{ height: 40 }}
                                  onClick={() =>
                                    handleOpen(
                                      index,
                                      'costingProject',
                                      '',
                                      properties?.NO_OF_PROJECTS_INVOLVED || NO_OF_PROJECTS_INVOLVED
                                    )
                                  }
                                >
                                  <p style={{ fontWeight: 'bold', color: 'blue', cursor: 'pointer' }}>
                                    {x.data[0].Total_No_of_Projects}
                                  </p>
                                </td>
                                <td
                                  style={{ height: 40 }}
                                  onClick={() => handleOpen(index, 'totalTasks', '', 'Total No of Tasks')}
                                >
                                  <p style={{ fontWeight: 'bold', color: 'blue', cursor: 'pointer' }}>
                                    {x.data[0].Total_No_of_Tasks}
                                  </p>
                                </td>
                                <td>
                                  <p>
                                    {x.data[0].Total_No_of_Hours_Worked !== null
                                      ? getDecimalHours(x.data[0].Total_No_of_Hours_Worked)
                                      : 0}
                                  </p>
                                </td>
                                {/* <td>{x.pay_rate}</td> */}
                                <td>
                                  {x.data[0].Total_No_of_Hours_Worked !== null && x.pay_rate !== 0
                                    ? (x.data[0].Total_No_of_Hours_Worked * x.pay_rate).toFixed(2)
                                    : '0'}
                                </td>
                                <td>
                                {x.data[0].Total_No_of_Hours_Worked !== null && x.bill_rate !== 0
                                  ? (x.data[0].Total_No_of_Hours_Worked * x.bill_rate).toFixed(2)
                                  : '0'}
                              </td>
                              </tr>
                            )
                          )}
                        </tbody>
                      </table>
                    </div>
                  ) : loader ? (
                    <RootLoader />
                  ) : null}
                  {(open.action === 'costingProject' || open.action === 'totalTasks') && (
                    <UserProjectInfo
                      open={open.status}
                      data={info}
                      handleClose={handleClose}
                      handleModalClose={handleModalClose}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <ProjectCosting onSwitch={() => setActiveComponent('user')} filter={filter} />
      )}
    </div>
  );
};

export default UserCosting;